import { render, staticRenderFns } from "./ResourceRoomType.vue?vue&type=template&id=6d04298c&scoped=true"
import script from "./ResourceRoomType.vue?vue&type=script&lang=js"
export * from "./ResourceRoomType.vue?vue&type=script&lang=js"
import style0 from "./ResourceRoomType.vue?vue&type=style&index=0&id=6d04298c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d04298c",
  null
  
)

export default component.exports